<template>
  <div id="methodology" style="padding: 80px 0; background: #ffffff;">
    <div class="container">
      <div class="text-center mb-5">
        <h2 style="font-size: 3rem; font-weight: 700; color: #1a202c; margin-bottom: 16px;">Our Methodology</h2>
        <p style="font-size: 1.2rem; color: #4a5568; max-width: 600px; margin: 0 auto;">
          Our approach is founded on industry best practices and a relentless commitment to security and customer satisfaction.
        </p>
      </div>
      <div class="row text-center">
        <div class="col-md-4 mb-4">
          <div class="card h-100" style="border: none; border-radius: 12px; box-shadow: 0 4px 15px rgba(0,0,0,0.08); padding: 30px;">
            <div style="font-size: 3rem; color: #667eea; margin-bottom: 20px;">🤝</div>
            <h4 style="font-weight: 600; margin-bottom: 12px; color: #1a202c;">Customer-Centric</h4>
            <p style="color: #4a5568; line-height: 1.6;">We listen to our customers and align our solutions with your business objectives.</p>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="card h-100" style="border: none; border-radius: 12px; box-shadow: 0 4px 15px rgba(0,0,0,0.08); padding: 30px;">
            <div style="font-size: 3rem; color: #667eea; margin-bottom: 20px;">🛡️</div>
            <h4 style="font-weight: 600; margin-bottom: 12px; color: #1a202c;">Security is Job Zero</h4>
            <p style="color: #4a5568; line-height: 1.6;">We prioritize security in everything we do, from architecture to deployment.</p>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="card h-100" style="border: none; border-radius: 12px; box-shadow: 0 4px 15px rgba(0,0,0,0.08); padding: 30px;">
            <div style="font-size: 3rem; color: #667eea; margin-bottom: 20px;">🏛️</div>
            <h4 style="font-weight: 600; margin-bottom: 12px; color: #1a202c;">Best Practices</h4>
            <p style="color: #4a5568; line-height: 1.6;">We follow well-architected frameworks and the principle of least privilege.</p>
          </div>
        </div>
      </div>
      <div class="text-center mt-4">
        <NuxtLink to="/methodology" class="btn btn-primary">Learn More</NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
// No script needed for this component
</script>

<style scoped>
/* Any additional styling for the methodology section can go here */
</style>
